// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/site_contact/v1/site_contact.proto (package fingertip.creator.site_contact.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BoolValue, Int32Value, proto3, StringValue, Timestamp } from "@bufbuild/protobuf";
import { Address } from "../../../common/type/v1/address_pb.js";
import { SiteContact } from "../../../common/type/v1/site_contact_pb.js";
import { SiteContactTag } from "../../../common/type/v1/site_contact_tag_pb.js";
import { SiteContactMarketingStatus } from "../../../common/enum/v1/site_contact_marketing_status_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";

/**
 * @generated from message fingertip.creator.site_contact.v1.SiteContactAddress
 */
export const SiteContactAddress = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.SiteContactAddress",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "updated_at", kind: "message", T: Timestamp },
    { no: 7, name: "address", kind: "message", T: Address },
    { no: 8, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "is_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "is_billing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.SiteContactItem
 */
export const SiteContactItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.SiteContactItem",
  () => [
    { no: 1, name: "site_contact", kind: "message", T: SiteContact },
    { no: 2, name: "tags", kind: "message", T: SiteContactTag, repeated: true },
    { no: 3, name: "addresses", kind: "message", T: SiteContactAddress, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactPublicRequest
 */
export const GetSiteContactPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactPublicResponse
 */
export const GetSiteContactPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactPublicResponse",
  () => [
    { no: 1, name: "site_contact_item", kind: "message", T: SiteContactItem },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactRequest
 */
export const GetSiteContactRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactResponse
 */
export const GetSiteContactResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactResponse",
  () => [
    { no: 1, name: "site_contact_item", kind: "message", T: SiteContactItem },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactsItem
 */
export const GetSiteContactsItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactsItem",
  () => [
    { no: 1, name: "site_contact", kind: "message", T: SiteContact },
    { no: 2, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "form_responses_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "appointments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "orders_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "invoices_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "quotes_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "payments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "payment_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "tags", kind: "message", T: SiteContactTag, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactsRequest
 */
export const GetSiteContactsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "has_segmentation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "has_ratings", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "has_form_responses", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "has_appointments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "has_orders", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "has_invoices", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "has_quotes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "has_payments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "created_after", kind: "message", T: Timestamp },
    { no: 14, name: "marketing_statuses", kind: "enum", T: proto3.getEnumType(SiteContactMarketingStatus), repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactsResponse
 */
export const GetSiteContactsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetSiteContactsItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactContext
 */
export const CreateSiteContactContext = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactContext",
  () => [
    { no: 1, name: "file_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_src", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactRequest
 */
export const CreateSiteContactRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "unsubscribe_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "marketing_status", kind: "enum", T: proto3.getEnumType(SiteContactMarketingStatus) },
    { no: 26, name: "date_of_birth", kind: "message", T: Timestamp },
    { no: 27, name: "pronouns", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "tag_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 30, name: "context", kind: "message", T: CreateSiteContactContext },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactResponse
 */
export const CreateSiteContactResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "site_contact_item", kind: "message", T: SiteContactItem },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.StringList
 */
export const StringList = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.StringList",
  () => [
    { no: 1, name: "values", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactRequest
 */
export const UpdateSiteContactRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "message", T: StringValue },
    { no: 3, name: "name", kind: "message", T: StringValue },
    { no: 4, name: "phone", kind: "message", T: StringValue },
    { no: 5, name: "first_name", kind: "message", T: StringValue },
    { no: 6, name: "last_name", kind: "message", T: StringValue },
    { no: 7, name: "business_name", kind: "message", T: StringValue },
    { no: 8, name: "job_title", kind: "message", T: StringValue },
    { no: 14, name: "currency", kind: "message", T: StringValue },
    { no: 16, name: "source", kind: "message", T: StringValue },
    { no: 17, name: "language", kind: "message", T: StringValue },
    { no: 21, name: "unsubscribe_reason", kind: "message", T: StringValue },
    { no: 22, name: "time_zone", kind: "message", T: StringValue },
    { no: 23, name: "marketing_status", kind: "message", T: Int32Value },
    { no: 25, name: "date_of_birth", kind: "message", T: Timestamp },
    { no: 26, name: "pronouns", kind: "message", T: StringValue },
    { no: 27, name: "gender", kind: "message", T: StringValue },
    { no: 28, name: "tag_names", kind: "message", T: StringList },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactResponse
 */
export const UpdateSiteContactResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "site_contact_item", kind: "message", T: SiteContactItem },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactPublicRequest
 */
export const UpdateSiteContactPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactPublicRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "message", T: StringValue },
    { no: 4, name: "phone", kind: "message", T: StringValue },
    { no: 5, name: "first_name", kind: "message", T: StringValue },
    { no: 6, name: "last_name", kind: "message", T: StringValue },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactPublicResponse
 */
export const UpdateSiteContactPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.SendSiteContactDetailsPublicRequest
 */
export const SendSiteContactDetailsPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.SendSiteContactDetailsPublicRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "message", T: StringValue },
    { no: 4, name: "phone", kind: "message", T: StringValue },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.SendSiteContactDetailsPublicResponse
 */
export const SendSiteContactDetailsPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.SendSiteContactDetailsPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "has_account", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "new", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UnsubscribeSiteContactPublicRequest
 */
export const UnsubscribeSiteContactPublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UnsubscribeSiteContactPublicRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UnsubscribeSiteContactPublicResponse
 */
export const UnsubscribeSiteContactPublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UnsubscribeSiteContactPublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.DeleteSiteContactRequest
 */
export const DeleteSiteContactRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.DeleteSiteContactRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.DeleteSiteContactResponse
 */
export const DeleteSiteContactResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.DeleteSiteContactResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactOverviewRequest
 */
export const GetSiteContactOverviewRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactOverviewRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.GetSiteContactOverviewResponse
 */
export const GetSiteContactOverviewResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.GetSiteContactOverviewResponse",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rating", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "form_responses_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "appointments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "orders_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "invoices_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "quotes_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "payments_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "payment_amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "tags", kind: "message", T: SiteContactTag, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.BulkCreateSiteContactsRequest
 */
export const BulkCreateSiteContactsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.BulkCreateSiteContactsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "contacts", kind: "message", T: CreateSiteContactInput, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactInput
 */
export const CreateSiteContactInput = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactInput",
  () => [
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "first_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "last_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "business_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "job_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "unsubscribe_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "time_zone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "marketing_status", kind: "enum", T: proto3.getEnumType(SiteContactMarketingStatus) },
    { no: 26, name: "date_of_birth", kind: "message", T: Timestamp },
    { no: 27, name: "pronouns", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 29, name: "tag_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.BulkCreateSiteContactsResponse
 */
export const BulkCreateSiteContactsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.BulkCreateSiteContactsResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "total_created", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "failed_emails", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactAddressRequest
 */
export const CreateSiteContactAddressRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactAddressRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "nickname", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "address", kind: "message", T: Address },
    { no: 4, name: "is_default", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_billing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "is_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.CreateSiteContactAddressResponse
 */
export const CreateSiteContactAddressResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.CreateSiteContactAddressResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "site_contact_address", kind: "message", T: SiteContactAddress },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactAddressRequest
 */
export const UpdateSiteContactAddressRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactAddressRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "nickname", kind: "message", T: StringValue },
    { no: 4, name: "address", kind: "message", T: Address },
    { no: 5, name: "is_default", kind: "message", T: BoolValue },
    { no: 6, name: "is_billing", kind: "message", T: BoolValue },
    { no: 7, name: "is_shipping", kind: "message", T: BoolValue },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.UpdateSiteContactAddressResponse
 */
export const UpdateSiteContactAddressResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.UpdateSiteContactAddressResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "site_contact_address", kind: "message", T: SiteContactAddress },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.DeleteSiteContactAddressRequest
 */
export const DeleteSiteContactAddressRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.DeleteSiteContactAddressRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.DeleteSiteContactAddressResponse
 */
export const DeleteSiteContactAddressResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.DeleteSiteContactAddressResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.ExportSiteContactsRequest
 */
export const ExportSiteContactsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.ExportSiteContactsRequest",
  () => [
    { no: 1, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.site_contact.v1.ExportSiteContactsResponse
 */
export const ExportSiteContactsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.site_contact.v1.ExportSiteContactsResponse",
  () => [
    { no: 1, name: "csv_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

